import React from 'react';
import { doctorInfo } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Award, BookOpen, Users, Heart } from 'lucide-react';

const About = () => {
  const stats = [
    { icon: BookOpen, value: '112+', label: 'Published Papers' },
    { icon: Award, value: '15+', label: 'International Fellowships' },
    { icon: Users, value: '1000+', label: 'Patients Treated' },
    { icon: Heart, value: '20+', label: 'Years in Medicine' }
  ];

  return (
    <section id="about" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About Dr. Koyyala
          </h2>
          <div className="w-24 h-1 bg-teal-700 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              {doctorInfo.about.summary}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              {doctorInfo.about.experience}
            </p>
          </div>

          <div className="bg-teal-50 p-8 rounded-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">My Philosophy</h3>
            <p className="text-lg text-gray-700 leading-relaxed italic">
              "{doctorInfo.about.philosophy}"
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <Card key={stat.label} className="text-center hover:shadow-lg transition-shadow duration-300">
                <CardContent className="pt-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-teal-100 rounded-full mb-4">
                    <Icon className="w-8 h-8 text-teal-700" />
                  </div>
                  <p className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</p>
                  <p className="text-sm text-gray-600">{stat.label}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;